export default __webpack_public_path__ + "static/media/stop-time.e683de2d.svg";